import React from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import ReactPlayer from 'react-youtube';
import { useHistory } from "react-router-dom";


const PopUpReferral = (props) => {
    const history = useHistory();

    const handleRedirect = () => {
        history.push('/biddeasy-docvault')
    }

    return (
        <Modal isOpen={props.showPopUpText} centered className='referral-popup'>
            <div dangerouslySetInnerHTML={{ __html: `<style>.modal-open .modal{max-height:none;}</style>` }}></div>
            <ModalHeader toggle={props.toggleInfoPopup} className='modal-header'></ModalHeader>
            <ModalBody className='modal-body'>
                {props?.title ? <div className='m-auto' style={{ padding: "0 1rem" }}>

                    <p> {props?.title}</p>
                </div> : null}

                {props?.imageUrl ?
                    <div className='m-auto'>
                        <img onClick={handleRedirect} src={props?.imageUrl} className="pop-img" />
                    </div>
                    : null}

                {props?.description ?
                    <div className='m-auto' style={{ padding: "0 1rem" }}>

                        <p> {props?.description}</p>
                    </div>
                    : null}

                {props?.videoUrl ?
                    <div className='m-auto' style={{ padding: "0 1rem" }}>

                        <ReactPlayer
                            url={props?.videoUrl}
                            width="100%"
                            height="300px"
                        />
                    </div>
                    : null}
            </ModalBody>
        </Modal>
    )
}

export default PopUpReferral